import {
  PayeeRequirement,
  PayeeRequirementExpirationStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorIsRequirementNotExpiring = (
  requirement: PayeeRequirement
) => {
  return (
    requirement.expirationStatus !== PayeeRequirementExpirationStatus.EXPIRING
  );
};
